import DeleteButton from "@app/components/delete-button.tsx";
import { InvoiceAdjustmentModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import { createColumnHelper } from "bi-lib";

interface Props {
    onDelete: (id: number) => void;
    costAmountTotal: number;
    rowCount: number;
}

const columnHelper = createColumnHelper<InvoiceAdjustmentModel>();
export const invoiceAdjustmentsTableDefinition = ({ onDelete, costAmountTotal, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => <DeleteButton onDelete={() => onDelete(item.row.original.invoiceAdjustmentId!)} />,
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.createdDate, {
        id: "createdDate",
        header: "Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.category, { id: "category", header: "Category" }),
    columnHelper.accessor((x) => x.subcategory, { id: "subcategory", header: "Subcategory" }),
    columnHelper.accessor((x) => x.amount, {
        id: "amount",
        header: "Amount",
        cell: (item) => formatUsd(item.getValue()),
        footer: () => formatUsd(costAmountTotal),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.comment, { id: "comment", header: "Comment" }),
];
